// frontend/shared-ui/src/components/Avatar.jsx
import React from "react";

const SIZE_MAP = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 56,
  xl: 80,
};

const FONT_MAP = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 18,
  xl: 24,
};

function initialsFrom(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function Avatar({
  src,
  name = "",
  size = "md",
  ring = false,
  className = "",
  style,
  ...rest
}) {
  const px = SIZE_MAP[size] || SIZE_MAP.md;
  const fontPx = FONT_MAP[size] || FONT_MAP.md;

  const classes = [
    "fh-avatar",
    `fh-avatar--${size}`,
    ring ? "fh-avatar--ring" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // Inline fallback dimensions — guarantees visibility even if CSS fails to load
  const inlineStyle = {
    width: px,
    height: px,
    fontSize: fontPx,
    ...style,
  };

  return (
    <span className={classes} style={inlineStyle} {...rest}>
      {src ? (
        <img
          src={src}
          alt={name || "avatar"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      ) : (
        initialsFrom(name)
      )}
    </span>
  );
}
